import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { BusinessDTO } from '../../models/business';

interface UsersState {
  authToken: string | null;
  userBusinesses: BusinessDTO[];
  selectedBusiness: BusinessDTO | null;
}

const initialState: UsersState = {
  authToken: null,
  userBusinesses: [],
  selectedBusiness: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setAuthToken: (state, action: PayloadAction<string>) => ({ ...state, authToken: action.payload }),
    setUserBusinesses: (state, action: PayloadAction<BusinessDTO[]>) => ({ ...state, userBusinesses: action.payload }),
    setSelectedBusiness: (state, action: PayloadAction<BusinessDTO>) => {
      Cookies.set('selectedBusiness', JSON.stringify(action.payload));
      Cookies.set('selectedBusinessId', `${action.payload.id}`);
      return { ...state, selectedBusiness: action.payload };
    },
    clearSelectedBusiness: (state) => {
      Cookies.remove('selectedBusiness');
      Cookies.remove('selectedBusinessId');
      return { ...state, selectedBusiness: null };
    },
  },
});

export const { setAuthToken, setUserBusinesses, setSelectedBusiness, clearSelectedBusiness } = usersSlice.actions;
export const usersReducer = usersSlice.reducer;
